"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProposalEditsProvider = void 0;
exports.useProposalEdits = useProposalEdits;
var _react = _interopRequireWildcard(require("react"));
var _proposalEditsStorage = require("../utils/proposal-edits-storage");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ProposalEditsContext = /*#__PURE__*/(0, _react.createContext)(null);
var ProposalEditsProvider = exports.ProposalEditsProvider = function ProposalEditsProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(function () {
      return (0, _proposalEditsStorage.loadProposalEdits)((0, _proposalEditsStorage.browserStorage)());
    }),
    _useState2 = _slicedToArray(_useState, 2),
    edits = _useState2[0],
    setEdits = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    editRequestedActionId = _useState4[0],
    setEditRequestedActionId = _useState4[1];
  (0, _react.useEffect)(function () {
    (0, _proposalEditsStorage.saveProposalEdits)((0, _proposalEditsStorage.browserStorage)(), edits);
  }, [edits]);
  var editsOf = (0, _react.useCallback)(function (conversationId) {
    var _edits$get;
    return (_edits$get = edits.get(conversationId)) !== null && _edits$get !== void 0 ? _edits$get : _proposalEditsStorage.NO_PROPOSAL_EDITS;
  }, [edits]);
  var getEdit = (0, _react.useCallback)(function (conversationId, actionId) {
    var _edits$get2;
    return (_edits$get2 = edits.get(conversationId)) === null || _edits$get2 === void 0 ? void 0 : _edits$get2.get(actionId);
  }, [edits]);
  var saveEdit = (0, _react.useCallback)(function (conversationId, actionId, edit) {
    setEdits(function (previous) {
      var _previous$get;
      var editsByAction = new Map((_previous$get = previous.get(conversationId)) !== null && _previous$get !== void 0 ? _previous$get : []);
      editsByAction.set(actionId, _objectSpread(_objectSpread({}, edit), {}, {
        editedAt: new Date().toISOString()
      }));
      return new Map(previous).set(conversationId, editsByAction);
    });
  }, []);
  var clearEdit = (0, _react.useCallback)(function (conversationId, actionId) {
    setEdits(function (previous) {
      var _previous$get2;
      var editsByAction = new Map((_previous$get2 = previous.get(conversationId)) !== null && _previous$get2 !== void 0 ? _previous$get2 : []);
      editsByAction.delete(actionId);
      var next = new Map(previous);
      if (editsByAction.size === 0) next.delete(conversationId);else next.set(conversationId, editsByAction);
      return next;
    });
  }, []);
  var requestEdit = (0, _react.useCallback)(function (actionId) {
    return setEditRequestedActionId(actionId);
  }, []);
  var clearEditRequest = (0, _react.useCallback)(function () {
    return setEditRequestedActionId(null);
  }, []);
  var value = (0, _react.useMemo)(function () {
    return {
      editsOf: editsOf,
      getEdit: getEdit,
      saveEdit: saveEdit,
      clearEdit: clearEdit,
      editRequestedActionId: editRequestedActionId,
      requestEdit: requestEdit,
      clearEditRequest: clearEditRequest
    };
  }, [editsOf, getEdit, saveEdit, clearEdit, editRequestedActionId, requestEdit, clearEditRequest]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProposalEditsContext.Provider, {
    value: value,
    "data-sentry-element": "ProposalEditsContext.Provider",
    "data-sentry-component": "ProposalEditsProvider",
    "data-sentry-source-file": "ProposalEditsContext.tsx",
    children: children
  });
};
function useProposalEdits() {
  var value = (0, _react.useContext)(ProposalEditsContext);
  if (value === null) throw new Error("useProposalEdits must be used within a ProposalEditsProvider");
  return value;
}